export const messagePatternVids = [
  { value: 0, label: "Вручную" },
  { value: 1, label: "После регистрации" },
  { value: 2, label: "После активации пробного периода" },
  { value: 3, label: "Перед окончанием пробного периода" },
  { value: 4, label: "После выписки счёта на оплату" },
  { value: 5, label: "После оплаты счёта" },
  { value: 6, label: "Перед блокировкой аккаунта" },
  { value: 7, label: "После блокировки аккаунта" },
  { value: 100, label: "Шаблон тела письма о получении сертификата" },
  { value: 101, label: "Шаблон вложения письма (сертификат)" },
];

export const getMessagePatternVidName = (value) =>
  messagePatternVids.find((v) => v.value === value)?.label ?? value;
